import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UtilityService } from 'src/app/core/utilities/utility.service';
import { TokenService } from '../../../services/token.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  constructor(
    private router: Router,
    private utility: UtilityService,
    private tokenservice:TokenService
  ) { }
  ngOnInit() {
  }
  get fullName(): string {
    const user = this.tokenservice.user;
    if (!user) return '';
    return `${user.firstName || ''} ${user.lastName || ''}`.trim();
  }

  // create initials
  get initials(): string {
    return this.fullName
      ? this.utility.getFirstLetters(this.fullName).toUpperCase()
      : '';
  }

  switchTab(tab: string) {
    this.router.navigate(['/dashboard', tab]);
  }
isActive(tab: string): boolean {
  if (tab === 'overview') {
    return this.router.url.includes('overview');
  }

  if (tab === 'vehicleslist') {
    return !this.router.url.includes('overview');
  }

  return false;
}
}
